import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { MainFrontendConfigFieldAccess } from 'src/modules/app-template/models/main-frontend-config-field-access.enum';
import { DatabaseUser } from 'src/modules/database/shared/database-user.entity';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'app-edit-general-users',
    templateUrl: './edit-general-users.component.html',
    styleUrls: ['./edit-general-users.component.scss']
  })
  export class EditGeneralUsersComponent extends ComponentView {

    listData: DatabaseUser[];
    table: TableData;

    private applyFieldAccess(col: TableColumn): TableColumn {
        let fa = this.app.mainConfig.adminUsersFieldAccess;
        if (fa == null) {
            return col;
        }
        if (Utils.getSafe(fa, col.id, MainFrontendConfigFieldAccess.editable) == MainFrontendConfigFieldAccess.hidden) {
            return null;
        }
        return col;
    }


    async initParams(): Promise<boolean> {
        this.listData = await this.app.loadDataHandler(async () => RestEndpoint.main().find({source: ""}).run("api/app/user").list(DatabaseUser), this);

        this.table = new TableData([
            new TableColumn("userName", "Benutzername", TableCellType.text, { autoWidth: 20 }),
            this.applyFieldAccess(new TableColumn("lastName", "Nachname", TableCellType.text, { autoWidth: 20 })),
            this.applyFieldAccess(new TableColumn("firstName", "Vorname", TableCellType.text, { autoWidth: 20 })),
            this.applyFieldAccess(new TableColumn("mail", "E-Mail", TableCellType.text, { autoWidth: 30 })),
            this.applyFieldAccess(new TableColumn("phone", "Telefon", TableCellType.text, { autoWidth: 15 })),
            this.applyFieldAccess(new TableColumn("isAdmin", "Administrator", TableCellType.yesNo, { autoWidth: 1 })),
            this.applyFieldAccess(new TableColumn("groups", "Gruppenzugehörigkeit", TableCellType.text, { autoWidth: 30 })),
        ], this.listData.map(o => new TableRow("", o, {
            userName: o.userName,
            lastName: o.lastName,
            firstName: o.firstName,
            mail: o.mail,
            phone: o.phone,
            isAdmin: o.isAdmin,
            groups: Utils.arrayItemsToString(Utils.arraySort(o.groups.map(g => g.name)))
        })), [new TableSortColumn("userName")]);

        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            { label: "Benutzer", routerLink: ["/base2", "admin", "editGeneralUsers"] }
        ]);

        return true;
    }
}
